module.exports = __webpack_public_path__ + "static/img/Group 829@2x.c995912.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/Group 829@2x.png
// module id = RFuN
// module chunks = 1